import { PlanfactOperation } from '../services/api';

export const BUDGET_ARTICLE_INCOME = 'ДОХОДЫ';
export const BUDGET_ARTICLE_EXPENSE = 'РАСХОДЫ';

export function normalizeOperationAmount(
  amount: number | string | undefined | null,
  operationType?: string,
): number {
  const numeric = Number(amount) || 0;
  if (operationType === 'Outcome') {
    return numeric > 0 ? -numeric : numeric;
  }
  return numeric;
}

export function expenseAmountMagnitude(value: number): number {
  return value <= 0 ? -value : value;
}

export function isComputedTaxOperation(
  operation: Pick<PlanfactOperation, 'source'>,
): boolean {
  return operation.source === 'tax';
}

export function isPlanfactSourceOperation(
  operation: Pick<PlanfactOperation, 'source'>,
): boolean {
  return !isComputedTaxOperation(operation);
}

export function excludeTaxOperations(operations: PlanfactOperation[]): PlanfactOperation[] {
  return operations.filter(isPlanfactSourceOperation);
}

export function isOperationReceipt(
  operation: Pick<PlanfactOperation, 'budget_article'>,
): boolean {
  return operation.budget_article?.trim() === BUDGET_ARTICLE_INCOME;
}

export function isOperationExpense(
  operation: Pick<PlanfactOperation, 'budget_article'>,
): boolean {
  return operation.budget_article?.trim() === BUDGET_ARTICLE_EXPENSE;
}
